import apiClient from './apiClient'



// Fetch pipeline details
const getPipelines = async (databaseName) => {
  // if (API_CONFIG.useMockData) {
  //   console.log('📦 Using mock data: pipelines', databaseName)
  //   return delay(mockPipelines[1] || [])
  // }
  
  const response = await apiClient.get(`/Pipeline/${databaseName}`)
  return response.data
}

const pipelineService = {
  getPipelines,
}

export default pipelineService
